function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

/** True when a Config save failed because the browser/network could not complete the request. */
export function isConfigSaveNetworkError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  if (
    normalized.includes("failed to fetch") ||
    normalized.includes("network error") ||
    normalized.includes("networkerror") ||
    normalized.includes("load failed") ||
    normalized.includes("network request failed")
  ) {
    return true;
  }
  return (
    error != null &&
    typeof error === "object" &&
    "networkError" in error &&
    (error as { networkError?: unknown }).networkError != null
  );
}

export function getConfigSaveErrorMessage(
  error: unknown,
  fallbackMessage: string,
  networkMessage: string,
): string {
  if (isConfigSaveNetworkError(error)) return networkMessage;
  if (error instanceof Error && error.message.trim()) return error.message;
  return fallbackMessage;
}
